"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var HomeIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(HomeIcon, _React$PureComponent);

  function HomeIcon() {
    _classCallCheck(this, HomeIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(HomeIcon).apply(this, arguments));
  }

  _createClass(HomeIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'home-icon')
      }, props), _react.default.createElement("g", null, _react.default.createElement("path", {
        fill: color,
        d: "M2.5,6 L4.5,6 C4.77614237,6 5,6.22385763 5,6.5 L5,11.5 C5,11.7761424 4.77614237,12 4.5,12 L3,12 C2.44771525,12 2,11.5522847 2,11 L2,6.5 C2,6.22385763 2.22385763,6 2.5,6 Z"
      }), _react.default.createElement("path", {
        fill: color,
        d: "M7.5,6 L9.5,6 C9.77614237,6 10,6.22385763 10,6.5 L10,11 C10,11.5522847 9.55228475,12 9,12 L7.5,12 C7.22385763,12 7,11.7761424 7,11.5 L7,6.5 C7,6.22385763 7.22385763,6 7.5,6 Z"
      }), _react.default.createElement("path", {
        fill: color,
        d: "M6.5395511,0.308820777 L11.7728798,5.72905411 C12.0605903,6.02703996 12.0522605,6.50184063 11.7542746,6.7895511 C11.6144537,6.9245506 11.427686,7 11.2333287,7 L0.766671261,7 C0.352457698,7 0.0166712606,6.66421356 0.0166712606,6.25 C0.0166712606,6.05564272 0.0921206655,5.86887503 0.227120165,5.72905411 L5.4604489,0.308820777 C5.74815937,0.0108349357 6.22296004,0.00250509933 6.52094589,0.290215567 C6.52725594,0.296308033 6.53345863,0.302510724 6.5395511,0.308820777 Z"
      }), _react.default.createElement("path", {
        fill: color,
        d: "M5,7 L7,7 L7,9 L7,8.5 C7,8.22385763 6.77614237,8 6.5,8 L5.5,8 C5.22385763,8 5,8.22385763 5,8.5 L5,9 L5,7 Z"
      })));
      /* eslint-enable max-len */
    }
  }]);

  return HomeIcon;
}(_react.default.PureComponent);

exports.default = HomeIcon;
HomeIcon.defaultProps = {
  color: 'inherit'
};
HomeIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};